import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Breadcrumb from './components/Breadcrumb';
import GoogleAnalytics from './components/GoogleAnalytics';
import CookieConsent from './components/CookieConsent';
import CursorTrail from './components/CursorTrail';
import { CurrencyProvider } from './context/CurrencyContext';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';

import Collections from './pages/Collections';
import CategoryPage from './pages/CategoryPage';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Jewelry from './pages/Jewelry';
import NewArrivals from './pages/NewArrivals';
import Sale from './pages/Sale';
import Categories from './pages/Categories';
import FAQ from './pages/FAQ';
import Shipping from './pages/Shipping';
import Returns from './pages/Returns';
import SizeGuide from './pages/SizeGuide';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import OrderSuccess from './pages/OrderSuccess';
import NotFound from './pages/NotFound';
import Compare from './pages/Compare';
import Blog from './pages/Blog';
import BlogList from './pages/BlogList';

function App() {
  return (
    <HelmetProvider>
      <CurrencyProvider>
        <Router>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen bg-black">
            <CursorTrail />
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/collections/:category" element={<CategoryPage />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/jewelry" element={<Jewelry />} />
                <Route path="/new-arrivals" element={<NewArrivals />} />
                <Route path="/sale" element={<Sale />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/shipping" element={<Shipping />} />
                <Route path="/returns" element={<Returns />} />
                <Route path="/size-guide" element={<SizeGuide />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/cookies" element={<Cookies />} />
                <Route path="/orders/success" element={<OrderSuccess />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/blog" element={<BlogList />} />
                <Route path="/blog/:slug" element={<Blog />} />
                <Route path="*" element={<NotFound />} />
              </Routes >
            </main >
            <Footer />
            <Toaster
              position="bottom-right"
              toastOptions={{
                duration: 2000,
                style: {
                  background: '#1a1a1a',
                  color: '#fff',
                  border: '1px solid #333',
                },
              }}
            />
          </div >
        </Router >
      </CurrencyProvider >
    </HelmetProvider >
  );
}

export default App;
